import { MutableRefObject, ReactNode } from 'react';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';

import { ProgressBar } from 'primereact/progressbar';

const FormContainer = (props: {
  className?: string;
  loading: boolean;
  errors: MutableRefObject<any>;
  onSubmit: () => void;
  onCancel?: () => void;
  footer?: ReactNode;
  children: ReactNode;
  disableSubmit?: boolean;
}): JSX.Element => {
  const { className, loading, errors, onSubmit, onCancel, footer, children, disableSubmit } = props;

  const footerTemplate = () => {
    if (footer) return footer;

    return (
      <>
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-secondary p-button mr-3"
          onClick={onCancel}
          type="button"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          className="p-button-primary p-button"
          type="submit"
          loading={loading}
          disabled={disableSubmit}
        />
      </>
    );
  };

  return (
    <div className={className}>
      {loading && <ProgressBar mode="indeterminate" className="mb-3" />}
      <Messages ref={errors} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          try {
            onSubmit();
          } catch (error) {
            console.error('Form submission error:', error);
            if (errors && errors.current) {
              errors.current?.show({
                severity: 'error',
                summary: 'Error:',
                detail: error instanceof Error ? error.message : 'An unknown error occurred',
                life: 10000,
              });
            }
          }
        }}
      >
        <div className="grow p-fluid p-input-filled">
          <div>{children}</div>
        </div>
        <div className="text-right">{footerTemplate()}</div>
      </form>
    </div>
  );
};

export default FormContainer;
